import { AdivareToggleHeight } from '@adivare/js-components';

window.addEventListener('DOMContentLoaded', () => {
  AdivareToggleHeight.init();
});
